class ComponentTabs extends Theme.Component {
  #listeners = [];

  connectedCallback() {
    this.elements.tabs.forEach((element, index) => {
      const handler = (event) => {
        event.preventDefault();
        this.showTab(index);
        this.showDetail(index);
      };

      element.addEventListener("click", handler);

      this.#listeners.push({ element, handler });
    });
  }

  disconnectedCallback() {
    this.#listeners.forEach(({ element, handler }) => {
      element.removeEventListener("click", handler);
    });

    this.#listeners = [];
  }

  showTab(index) {
    this.elements.tabs.forEach((element) => {
      element.classList.remove("active--true");
    });

    this.elements.tabs[index].classList.add("active--true");
  }

  showDetail(index) {
    this.elements.details.forEach((element) => {
      element.style.opacity = 0;
      element.style.display = "none";
    });

    const target = this.elements.details[index];

    target.style.display = "block";

    requestAnimationFrame(() => {
      target.style.opacity = 1;
      target.classList.add("active--true");
    });
  }
}

customElements.define("component-tabs", ComponentTabs);
